import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';
import { Id } from 'convex/_generated/dataModel';

export function useUpsertPlantSowingConfig() {
  return useMutation(api.plantSowingConfig.mutations.upsertPlantSowingConfig).withOptimisticUpdate(
    (localStore, { gardenId, plantId, seedBuffer, isActive, sowMonth, sowWeekOfMonth }) => {
      const sowing = {
        seedBuffer,
        isActive,
        ...(sowMonth !== undefined ? { sowMonth } : {}),
        ...(sowWeekOfMonth !== undefined ? { sowWeekOfMonth } : {}),
      };

      const current = localStore.getQuery(api.plantSowingConfig.queries.getSowingConfigsByGarden, {
        gardenId,
      });
      if (current === undefined) return;

      const exists = current.some((c) => c.plantId === plantId);
      if (exists) {
        localStore.setQuery(
          api.plantSowingConfig.queries.getSowingConfigsByGarden,
          { gardenId },
          current.map((c) =>
            c.plantId === plantId
              ? {
                  _id: c._id,
                  _creationTime: c._creationTime,
                  userId: c.userId,
                  gardenId: c.gardenId,
                  plantId: c.plantId,
                  ...sowing,
                }
              : c
          )
        );
      } else {
        localStore.setQuery(api.plantSowingConfig.queries.getSowingConfigsByGarden, { gardenId }, [
          ...current,
          {
            _id: `__opt_${Date.now()}` as unknown as Id<'plantSowingConfig'>,
            _creationTime: Date.now(),
            userId: '' as unknown as Id<'users'>,
            gardenId,
            plantId,
            ...sowing,
          },
        ]);
      }

      const defaults = localStore.getQuery(api.userPlantDefaults.queries.getUserPlantDefaults, {});
      if (defaults === undefined) return;

      const defaultExists = defaults.some((d) => d.plantId === plantId);
      if (defaultExists) {
        localStore.setQuery(
          api.userPlantDefaults.queries.getUserPlantDefaults,
          {},
          defaults.map((d) => (d.plantId === plantId ? { ...d, sowing } : d))
        );
      } else {
        localStore.setQuery(api.userPlantDefaults.queries.getUserPlantDefaults, {}, [
          ...defaults,
          {
            _id: `__opt_def_${Date.now()}` as unknown as Id<'userPlantDefaults'>,
            _creationTime: Date.now(),
            userId: '' as unknown as Id<'users'>,
            plantId,
            sowing,
          },
        ]);
      }
    }
  );
}
